<template>
  <!--::banner topo::-->
  <section v-if="topoBanner != ''" class="banner_part">
    <div class="img-avance">
      <img :src="$imagens + 'banner-home.jpg'" class="bg-img-fill" alt="">
    </div>
    <div class="container">
      <div class="row align-content-center">
        <div class="col-lg-6">
          <div class="banner_text aling-items-center">
            <div class="banner_text_iner textoBanner">
              <h5>{{ topoBanner[0].itiNome }}</h5>
              <h2>{{ topoBanner[0].itiReferencia }}</h2>
              <p class="hidden-sm hidden-xs" v-html="topoBanner[0].itiResumo1"></p>
              <router-link :to="topoBanner[0].itiLinkBtn1" class="btn_1 banner_btn">
                {{ topoBanner[0].itiTextoBtn1 }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>

  <!--::sobre nos::-->
  <section v-if="sobre != ''" class="team_part">
    <div class="container">
      <div class="row align-items-stretch">
        <div class="col-lg-6 p-0">
          <div class="team_img hidden-sm hidden-xs">
            <img :src="$imgURL + sobre[0].insInstitucionalImagens[0].itgUrlImagem" alt="">
          </div>
        </div>
        <div class="offset-lg-1 col-lg-5 align-self-center " style="position: relative; z-index: 10;">
          <div class="team_member_text">
            <h2>{{ sobre[0].itiNome }}</h2>
            <p v-html="sobre[0].itiResumo1"></p>
            <router-link :to="sobre[0].itiLinkBtn1" class="btn_1">
              {{ sobre[0].itiTextoBtn1 }}
            </router-link>
          </div>
        </div>
        <img :src="$imagens + 'section_overlay.png'" class="section_pattern">
      </div>
    </div>

  </section>

  <!--::Nossas principais características::-->
  <div class="passion_part">

    <div v-if="caracteristicasImagem != ''" class="img-avance">
      <img :src="$imagens + 'caracteristicas.jpg'" class="bg-img-fill">
    </div>

    <div v-if="caracteristicas != ''" class="container">
      <div class="row">
        <div class="col-lg-5">
          <div class="section_tittle">
            <h1>Nossas principais características</h1>
          </div>
        </div>
      </div>
      <div class="row">

        <div v-for="cara in caracteristicas" :key="cara.itiId" class="col-md-6 col-lg-3">
          <div class="single_passion h-100">
            <div class="single_passion_item">
              <img :src="$imagens + 'patten_bg.png'">
              <a href="#" class="passion_icon"> <i class="flaticon-compass"></i> </a>
              <h4>{{ cara.itiNome }}</h4>
              <p v-html="cara.itiResumo1"></p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!--::para o proprietário::-->
  <section class="sec-proprietario">

    <div class="proprietario-container">
      <section v-if="tituloProprietario != ''" class="proprietario-intro">
        <p class="proprietario-texto-auxiliar">{{ tituloProprietario[0].itiReferencia }}</p>
        <h1 class="proprietario-titulo-principal">{{ tituloProprietario[0].itiNome }}</h1>
        <a :href="tituloProprietario[0].itiLinkBtn1" class="proprietario-botao-cta">{{
          tituloProprietario[0].itiTextoBtn1 }}</a>
      </section>

      <section v-if="detalhesProprietario != ''" class="proprietario-cards-wrapper">

        <div class="proprietario-card proprietario-card-sem">
          <h2 class="proprietario-card-titulo">{{ detalhesProprietario[0].itiNome }}</h2>
          <div class="proprietario-lista">

            <div class=" proprietario-item">
              <img :src="$imagens + (detalhesProprietario[0].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
              <div v-html="detalhesProprietario[0].itiDescricao1"></div>
            </div>

              <div class="proprietario-item">
                <img :src="$imagens + (detalhesProprietario[0].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
                <div v-html="detalhesProprietario[0].itiDescricao2"></div>
              </div>
            
              <div class="proprietario-item">
                <img :src="$imagens + (detalhesProprietario[0].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
                <div v-html="detalhesProprietario[0].itiDescricao3"></div>
              </div>
            
              <div class="proprietario-item">
                <img :src="$imagens + (detalhesProprietario[0].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
                <div v-html="detalhesProprietario[0].itiResumo1"></div>
              </div>
            
              <div class="proprietario-item">
                <img :src="$imagens + (detalhesProprietario[0].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
                <div v-html="detalhesProprietario[0].itiResumo2"></div>
              </div>
            
          </div>
        </div>

        <div class="proprietario-card proprietario-card-com">
          <h2 class="proprietario-card-titulo-2">{{ detalhesProprietario[1].itiNome }}</h2>
          <div class="proprietario-lista">

            <div class="proprietario-item">
              <img :src="$imagens + (detalhesProprietario[1].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
              <div v-html="detalhesProprietario[1].itiDescricao1"></div>
            </div>

            <div class="proprietario-item">
              <img :src="$imagens + (detalhesProprietario[1].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
              <div v-html="detalhesProprietario[1].itiDescricao2"></div>
            </div>

            <div class="proprietario-item">
              <img :src="$imagens + (detalhesProprietario[1].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
              <div v-html="detalhesProprietario[1].itiDescricao3"></div>
            </div>

            <div class="proprietario-item">
              <img :src="$imagens + (detalhesProprietario[1].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
              <div v-html="detalhesProprietario[1].itiResumo1"></div>
            </div>

            <div class="proprietario-item">
              <img :src="$imagens + (detalhesProprietario[1].itiDestaque ? 'positivo.jpg' : 'negativo.jpg')"
                class="proprietario-icon">
              <div v-html="detalhesProprietario[1].itiResumo2"></div>
            </div>
          </div>
        </div>

      </section>
    </div>
  </section>


  <!--::depoimentos::-->
  <div class="review_part" id="testimonial">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-lg-7">
          <div class="section_tittle">
            <h1>O que dizem nossos clientes</h1>
          </div>
        </div>
      </div>
      <div v-if="depoimentos && depoimentos.length > 0" class="row">
        <div class="col-lg-12">

          <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="2" :space-between="40"
            :autoplay="{ delay: 3000, disableOnInteraction: false }"
            :breakpoints="{ 768: { slidesPerView: 2 }, 0: { slidesPerView: 1 } }">
            <SwiperSlide v-for="depo in depoimentos" :key="depo.itiId">

              <div class="review_part_text ">
                <div class="singler_eview_part">
                  <div class="client_info">
                    <img :src="$imgURL + depo.insInstitucionalImagens[0].itgUrlImagem" alt="">
                    <h4>{{ depo.itiNome }}</h4>
                  </div>
                  <p v-html="depo.itiResumo1"></p>
                </div>
              </div>

            </SwiperSlide>
          </Swiper>

        </div>
      </div>
    </div>
  </div>

  <!--::planos::-->
  <section v-if="listaServicos.length > 0" class="planos_part">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="section_tittle">
            <h1>Nossos Planos</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="planos in listaServicos[0].insInstitucionalGrids.filter(item => item.insListaGaleriaInstGrids?.lgtId === 5)"
          :key="planos.igsId" class="col-lg-4 col-md-6 mb-4">
          <div class="planos_card">
            <div>
              <h3>{{ planos.igsNome }}</h3>
              <ul class="planos_list">
                <li v-html="planos.igsResumo"></li>
              </ul>
            </div>
            <router-link :to="'/contato'" class="btn_planos">ASSINE JÁ</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>

  <PageCallAction></PageCallAction>

  <!--::noticias::-->
  <div v-if="listaBlog.length > 0" class="blog_part">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-lg-5">
          <div class="section_tittle">
            <h1>Confira nossas últimas notícias</h1>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-md-6 col-lg-7">
          <div v-for="noticia in primeiraNoticia" :key="noticia.itiId" class="single_blog">
            <div class="appartment_img">
              <img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem">
            </div>
            <div class="single_appartment_content">
              <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                class="d-inline-block">
                <h4>{{ noticia.itiNome }}</h4>
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-5">
          <div class="right_single_blog">
            <div v-for="noticiaPequena in listaBlog.slice(1, 4)" :key="noticiaPequena.itiId" class="single_blog">
              <div class="media">
                <img :src="$imgURL + noticiaPequena.insInstitucionalImagens[0].itgUrlImagem" alt="post"
                  class="img-fluid mr-3 tamanho">
                <div class="media-body align-self-center">
                  <router-link :to="'/BlogDetalhe/' + noticiaPequena.itiId + '/' + formataLink(noticiaPequena.itiNome)">
                    <h5 class="mt-0">{{ noticiaPequena.itiNome }}</h5>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import PageCallAction from '../components/PageCallAction.vue';
import { useHead } from '@vueuse/head';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  name: 'HomeView',
  components: {
    PageCallAction,
    Swiper,
    SwiperSlide,
  },

  data: () => ({
    topoBanner: [],
    sobre: [],
    caracteristicas: [],
    caracteristicasImagem: [],
    tituloProprietario: [],
    detalhesProprietario: [],
    depoimentos: [],
    listaServicos: [],
    listaBlog: [],
  }),

  computed: {
    primeiraNoticia() {
      return this.listaBlog.length > 0 ? [this.listaBlog[0]] : [];
    }
  },

  methods: {

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },

    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    },

    carregaMetas(texto) {
      useHead({
        title: 'Garante Max :: Home',
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    // TOPO BANNER
    axios.get('/Process/InsInstitucional/institucional/34/slides/0/x')
      .then(response => {
        this.topoBanner = response.data;
        //console.log('topo Banner')
        //console.log(this.topoBanner)
      })
      .catch(error => {
        console.error(error);
      });

    // SOBRE
    axios.get('/Process/InsInstitucional/institucional/38/apresentacao/0/x')
      .then(response => {
        this.sobre = response.data;
        //console.log('sobre')
        //console.log(this.sobre)
      })
      .catch(error => {
        console.error(error);
      });

    // CARACTERÍSTICAS
    axios.get('/Process/InsInstitucional/institucional/39/apresentacaodetalhes/0/x')
      .then(response => {
        this.caracteristicas = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('caracteristicas')
        //console.log(this.caracteristicas)
      })
      .catch(error => {
        console.error(error);
      });

    // CARACTERÍSTICAS IMAGEM FUNDO
    axios.get('/Process/InsInstitucional/institucional/61/apresentacaodetalhesfundo/0/x')
      .then(response => {
        this.caracteristicasImagem = response.data;
        //console.log('caracteristicasImagem')
        //console.log(this.caracteristicasImagem)
      })
      .catch(error => {
        console.error(error);
      });

    // PARA O PROPRIETÁRIO TITULO
    axios.get('/Process/InsInstitucional/institucional/62/tiutlotabela/0/x')
      .then(response => {
        this.tituloProprietario = response.data;
        //console.log('tituloProprietario')
        //console.log(this.tituloProprietario)
      })
      .catch(error => {
        console.error(error);
      });

    // PARA O PROPRIETÁRIO DETALHES
    axios.get('/Process/InsInstitucional/institucional/63/itenstabela/0/x')
      .then(response => {
        this.detalhesProprietario = response.data;
        //console.log('detalhesProprietario')
        //console.log(this.detalhesProprietario)
      })
      .catch(error => {
        console.error(error);
      });

    // DEPOIMENTOS
    axios.get('/Process/InsInstitucional/institucional/42/depoimentos/0/x')
      .then(response => {
        this.depoimentos = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('depoimentos')
        //console.log(this.depoimentos)
      })
      .catch(error => {
        console.error(error);
      });

    // PLANOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaServicos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaServicos')
        //console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });

    // BLOG
    axios.get('/Process/InsInstitucional/institucional/50/noticias/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        //console.log('listaBlog')
        //console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });

  },
}

</script>

<style scoped></style>
